import React from 'react'

export default ({ color = '#366CE1', height = '12px', width = '12px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.314094 10.1611L4.48054 5.99463L0.314094 1.82819C-0.104698 1.4094 -0.104698 0.732886 0.314094 0.314094C0.732886 -0.104698 1.4094 -0.104698 1.82819 0.314094L6.75705 5.24295C7.17584 5.66175 7.17584 6.33826 6.75705 6.75705L1.82819 11.6859C1.4094 12.1047 0.732886 12.1047 0.314094 11.6859C-0.0939597 11.2671 -0.104698 10.5799 0.314094 10.1611Z"
      fill={color}
    />
  </svg>
)
